import React from 'react';
import { createPortal } from 'react-dom';
import { connect } from 'react-redux';

import Modal from '../../../modal';
import UserSentiment from '../..';

import { closeUserSentiment as closeUserSentimentAction } from '../../actions';

import { AppState } from '../../../../reducers';

import * as S from './styles';

type StateProps = {
  modalIsOpen: boolean;
};

type DispatchProps = {
  closeUserSentiment: () => void;
};

type Props = StateProps & DispatchProps;

const UserSentimentModal = ({ modalIsOpen, closeUserSentiment }: Props) => {
  if (!IS_BROWSER) return null;

  const rootElement = document.getElementById('root-modal');

  return rootElement
    ? createPortal(
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeUserSentiment}
          width={300}
          center
          shouldShowCloseIcon={false}
          data-test="UserSentimentModal"
        >
          <S.Inner>
            <UserSentiment closeUserSentiment={closeUserSentiment} />
          </S.Inner>
        </Modal>,
        rootElement
      )
    : null;
};

const mapStateToProps = (state: AppState) => ({
  modalIsOpen: state.userSentiment.isOpen,
});

const dispatchActions = {
  closeUserSentiment: closeUserSentimentAction,
};

export default connect(mapStateToProps, dispatchActions)(UserSentimentModal);
